import { Logger } from 'tslog';

export const log: Logger = new Logger({
  displayFilePath: 'displayAll',
  overwriteConsole: false,
  exposeErrorCodeFrame: true,
  minLevel: 'warn',
});
